import { updateUserISTColumnList } from 'src/api/genericConsignmentView';
import { getAllTmsDataIST, getTmsSummaryMetricsDataIST } from '../../api/TMSDashboard/ISTView';
const defaultRetailStatusFilterOptions = [
  'reachedathub',
  'outfordelivery',
  'delivered',
  'attempted',
  'inscan_at_hub',
  'in_transit',
  'pickup_awaited',
  'pickup_scheduled',
  'out_for_pickup',
  'not_picked_up',
  'pickup_completed',
];

const viewControl = {
  pageTitle: 'Trips',
  buckets : [
    'tms_ist_created',
    'tms_ist_expected',
    'tms_ist_arrived',
    'tms_ist_unloading',
    'tms_ist_loading',
    'tms_ist_loaded',
    'tms_ist_departed',
    'tms_ist_completed',

  ],
  navBar : {
    left : ['single_hub_search', 'date_filter'],
    right : ['search_redirect'],
  },
  globalActions:[],
  dateFilterOptions : [
    { key:'last_status_change_time', val:'Last Updated' },
    { key:'created_at', val:'Creation Date' },
  ],
  searchFilterOptions : [
    { key:'vehicle_number', val: 'Vehicle No.' },
    { key:'ist_reference_number', val: 'Trip No.' },
  ],
  fetchData : getAllTmsDataIST,
  fetchSummaryMetrics : getTmsSummaryMetricsDataIST,
  updateUserColumnList: updateUserISTColumnList,
};
const buckets = {
  tms_ist_created : {
    name: 'Created',
    filters : [
      'status',
      'attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
    ],
    actions : [
      // 'addCN',
      {
        key:'ist_load',
        name:'Load',
        isAllowed:
        masterData => masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.load,
      },
    ],
    status_filter: defaultRetailStatusFilterOptions,

  },
  tms_ist_arrived : {
    name:'Arrived',
    filters : [
      // 'planned', // not included in filterpopup
      'status',
      'attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
    ],
    actions : [
      // 'createRoute',
      // 'unassign',
      {
        key:'dock_inscan',
        name:'Dock Inscan',
        isAllowed: masterData =>  masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.dockInScan,
        },
      {
        key:'ist_load',
        name:'Load',
        isAllowed:
        masterData => masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.load,
      },
      {
        key:'ist_unload',
        name:'Unload',
        isAllowed:
        masterData => masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.unload,
      },
      {
        key:'trip_manifest',
        name:'Print Manifest',
        isAllowed: masterData => masterData.show_logistics_express_options &&
              masterData.ops_dashboard_config?.parts_to_show?.allow_label_print ,
      },
    ],
    status_filter: defaultRetailStatusFilterOptions,

  },
  tms_ist_unloading : {
    hidePagination : false,
    hidePerPageCount :false,
    name:'Unloading',
    filters : [
      // 'planned', // not included in filterpopup
      'status',
      'attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
    ],
    actions : [
      // 'createRoute',
      // 'unassign',
      {
        key:'close_ist',
        name:'Close Trip'
      },
      {
        key:'ist_load',
        name:'Load',
        isAllowed:
        masterData => masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.load,
      },
      {
        key:'ist_unload',
        name:'Unload',
        isAllowed:
        masterData => masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.unload,
      },
      {
        key:'trip_manifest',
        name:'Print Manifest',
        isAllowed: masterData => masterData.show_logistics_express_options &&
              masterData.ops_dashboard_config?.parts_to_show?.allow_label_print ,
      },
    ],
    status_filter: defaultRetailStatusFilterOptions,

  },
  tms_ist_loading : {
    name: 'Loading',
    filters : [
      'status',
      'attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
    ],
    actions: [
      {
        key:'ist_load',
        name:'Load',
        isAllowed:
        masterData => masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.load,
      },
      {
        key:'ist_freeze',
        name:'Freeze Trip',
        isAllowed:
        masterData => masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.freeze,
      },
      {
        key:'trip_manifest',
        name:'Print Manifest',
        isAllowed: masterData => masterData.show_logistics_express_options &&
              masterData.ops_dashboard_config?.parts_to_show?.allow_label_print ,
      },
    ],
    status_filter : defaultRetailStatusFilterOptions,
  },
  tms_ist_loaded : {
    name: 'Loaded',
    filters : [
      'status',
      'attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
    ],
    actions: [
      {
        key:'depart_ist',
        name:'Trip Depart',
      },
      {
        key:'dock_outscan',
        name:'Dock Outscan',
        isAllowed: masterData =>  masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.dockOutScan,
      },
      {
        key:'gate_out',
        name:'Gate Out',
        isAllowed: masterData => masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.gateOut,
      },
      {
        key:'trip_manifest',
        name:'Print Manifest',
        isAllowed: masterData => masterData.show_logistics_express_options &&
              masterData.ops_dashboard_config?.parts_to_show?.allow_label_print ,
      },
    ],
    status_filter : defaultRetailStatusFilterOptions,
  },
  tms_ist_departed : {
    name: 'Departed',
    filters : [
      'status',
      'attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
    ],
    actions: [
      {
        key:'track_trace',
        name:'Track',
        isAllowed:
        masterData => masterData.ops_dashboard_config.parts_to_show.show_vehicle_midmile_track,
      },
      {
        key: 'apply_exception',
        name: 'Apply Exception',
      }
    ],
    status_filter : defaultRetailStatusFilterOptions,
  },
  tms_ist_completed: {
    name: 'Completed',
    filters : [
      'status',
      'attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
    ],
    actions: [
    ],
    status_filter : defaultRetailStatusFilterOptions,
  },
  tms_ist_expected: {
    name: 'Expected',
    filters : [
      'status',
      'attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
    ],
    actions: [
      {
        key:'gate_in_tag',
        name:'Gate In',
        isAllowed: masterData => masterData.ops_dashboard_config?.parts_to_show?.vehicle_actions?.gateIn,
      },
      {
        key:'receive_ist',
        name:'Receive Trip',
      },
      {
        key:'track_trace',
        name:'Track',
        isAllowed:
        masterData => masterData.ops_dashboard_config.parts_to_show.show_vehicle_midmile_track,
      },
      {
        key:'trip_manifest',
        name:'Print Manifest',
        isAllowed: masterData => masterData.show_logistics_express_options &&
              masterData.ops_dashboard_config?.parts_to_show?.allow_label_print ,
      }
    ],
    status_filter : defaultRetailStatusFilterOptions,
  }
};

const bucketColor = {
  tms_ist_created: '#EC5D2D',
  tms_ist_expected: '#EC5D2D',
  tms_ist_arrived: '#DA1A83',
  tms_ist_unloading: '#A11DAA',
  tms_ist_loading: '#93C848',
  tms_ist_loaded: '#27C69B',
  tms_ist_departed: '#25A4D0',
  tms_ist_completed: '#19CA2C',
};

export default { viewControl, buckets, bucketColor };
